export default function checkStringTelegramUserName(str) {
	if (str.includes("https://t.me/")) {
		str = str.replace("https://t.me/", "");
	}
	if (str.includes("@")) {
		str = str.replace("@", "");
	}
	return str;
}
